import { useMemo } from 'react'

import { Link } from 'react-router'

import { buildBreadcrumbsData, getSearchResultUrl } from './helpers'
import { SearchResultTileTitle } from './SearchResultTileTitle'
import { BreadcrumbBar } from '../../Breadcrumbs'
import { getSearchResultIcon } from '../../helpers'
import { SearchResult } from '~/types/search'

interface SearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const SearchResultTile = ({ result, onClose, tileKey }: SearchResultTileProps) => {

  const breadcrumbsData = useMemo(() => buildBreadcrumbsData({
    productName: result.product.name,
    tileKey,
    parents: result.parents || [],
    title: result.title
  }), [])

  return (
    <Link
      to={getSearchResultUrl(result)}
      onClick={onClose}
      className="group flex flex-row gap-2.5 px-2.5 py-3 cursor-pointer hover:bg-neutral-10 dark:hover:bg-neutral-90 hover:rounded w-full"
    >
      <div className="text-neutral-50 group-hover:text-neutral-70 dark:text-neutral-50 dark:group-hover:text-neutral-50">
        {getSearchResultIcon(result.resultType)}
      </div>
      <div className="flex flex-col w-full overflow-hidden">
        <SearchResultTileTitle result={result} />
        <BreadcrumbBar data={breadcrumbsData} />
        {result.snippet.length ? (
          <span className="mt-1 overflow-hidden break-words text-body3 dark:text-neutral-10 line-clamp-2">
            {result.snippet.map((snippetItem, snippetIndex) => {
              const key = `snippet-${snippetItem.text}-${snippetIndex}`
              return (
                <span
                  key={key}
                  className={snippetItem.highlight ?
                    'font-bold bg-neutral-10 dark:bg-neutral-85 group-hover:bg-neutral-30 dark:group-hover:bg-neutral-80 py-[0.169rem] -my-[0.169rem]'
                    : ''}
                >
                  {snippetItem.text}
                </span>
              )
            })}
          </span>
        ) : null}
      </div>
    </Link>
  )
}